<template>
  <div class="ranking-table-section">
    <div class="ranking-table-desc">
      {{ $t('ranking-description') }}
    </div>
    <div class="locallevelselector"><localLevelSelector :titulo-visible="true" @genericlevelchange="locallevelchange" /></div>
    <div class="ranking-table-container">
      <div v-if="tableData.length === 0">
        <div class="ranking-table-errmsg">{{ $t('no-data-level') }}</div>
      </div>
      <table v-else class="ranking-table" aria-hidden="true">
        <tr>
          <td colspan="3" />
        </tr>
        <tr
          v-for="(item, index) in tableData"
          :key="index"
          :class="highlightSelected(item)"
          @click="selectedTableData(item)"
          @mouseenter="hoverTableData(item)"
          @mouseleave="removeTableData(item)"
        >
          <td>
            <!-- <span v-if="geolevelselected.level === 5">{{ $t('district-ranking') }}: </span>
            <span v-if="geolevelselected.level === 7">{{ $t('sec-census-ranking') }}: </span> -->
            {{ item.label }}</td>
          <td><div :style="{ width: item.width, background: item.color }" /></td>
          <td><span>{{ formatNumber(item.value) }} <span class="ranking-unit">{{ unit }}</span></span></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
import { mapState } from 'vuex'
import localLevelSelector from '@/components/genericLevelSelector.vue'
export default {
  components: { localLevelSelector },
  data() {
    return {
      tableData: [],
      tableMinData: 0,
      tableMaxData: 0,
      unit: '',
      timer: 0,
      loadingData: false
    }
  },
  computed: {
    ...mapState('location', {
      // geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels
    }),
    ...mapState('maps', {
      mapvisualizationval: (state) => state.selectedmap.mapvisualizationval,
      currentMapViewStore: (state) => state.mapview,
      mappoint: (state) => state.mappoint
    })
  },
  watch: {
    geolevelselected: function() {
      if (!this.loadingData) {
        this.loadingData = true
        this.getTableData()
      }
    },
    mapvisualizationval: function() {
      // console.log('changed this map ')
      // console.log(this.loadingData)
      if (!this.loadingData) {
        this.loadingData = true
        this.getTableData()
      }
    }
  },
  mounted() {
    var vm = this
    if (!vm.loadingData) {
      vm.loadingData = true
      vm.getTableData()
    }
  },
  methods: {
    locallevelchange(geolevel) {
      this.geolevelselected = geolevel
      this.getTableData()
    },
    getTableData() {
      var vm = this
      if (vm.geolevelselected === null || vm.geolevelselected === undefined || vm.mapvisualizationval === 'satellite_view' || vm.mapvisualizationval === 'wms_view') {
        vm.loadingData = false
        return
      }
      const query = {
        country: vm.geolevels.filter((item) => item.level === 0).length === 0 ? 'Spain' : vm.geolevels.filter((item) => item.level === 0)[0].name,
        env: window._env_.VUE_APP_ENV_ARCGIS_SUFFIX === '_DEV' ? 'DEV' : 'PRO',
        typo: 0,
        geolevel: vm.geolevelselected,
        column: vm.mapvisualizationval
      }
      vm.$store.dispatch('ranking/getRankingData', query)
        .then((resp) => {
          this.loadingData = false
          if (resp.legend === null || resp.legend === 'null') {
            vm.tableData = []
            return
          }
          var dataArr = _.sortBy(resp.data, function(item) {
            return item.value
          }).reverse()
          vm.tableMinData = dataArr[dataArr.length - 1].value ? dataArr[dataArr.length - 1].value : 0
          vm.tableMaxData = dataArr[0].value
          vm.unit = resp.unit

          var legend = null
          if (resp.legend !== null && resp.legend !== undefined && resp.legend !== 'KO' && resp.legend.length > 0) {
            legend = JSON.parse(resp.legend)
            legend = vm.parseLegend(legend)
          }

          dataArr.forEach(element => {
            var widNum = ((parseFloat(element.value * 1.1) - parseFloat(vm.tableMinData)) / (parseFloat(vm.tableMaxData * 1.1) - parseFloat(vm.tableMinData))) * 100
            if (widNum < 0) { widNum = Math.abs(widNum) }
            element.width = widNum + '%'
            element.color = vm.getColor(parseFloat(element.value), legend)
            element.level = resp.level
          })

          vm.tableData = dataArr
        })
        .catch((error) => {
          console.error(error)
          // debugger
          this.loadingData = false
        })
    },
    getColor(element, legend) {
      if (legend === null || legend === undefined || legend.length < 1) { return '#99C9C5' }
      if (element < parseFloat(legend[0][0])) { return legend[0][1] }
      if (element >= parseFloat(legend[legend.length - 1][0])) { return legend[legend.length - 1][1] }
      for (var i = 0; i < legend.length; i++) {
        if (element >= legend[i][0] && element < legend[i + 1][0]) { return legend[i][1] }
      }
    },
    parseLegend(legend) {
      legend.forEach(element => {
        element[0] = element[0].split(' - ')[0].replace(/[^0-9,-]/g, '').replace(',', '.')
      })
      return legend
    },
    formatNumber(num) {
      if (num === null || num === undefined || parseFloat(num) === 0) { return '-' }
      return num.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    selectedTableData(item) {
      this.$root.$emit('SelectRankingItem', item)
    },
    hoverTableData(item) {
      var vm = this
      this.timer = setTimeout(function() {
        vm.$root.$emit('HoverRankingData', item)
      }, 200)
    },
    removeTableData(item) {
      clearTimeout(this.timer)
      this.$root.$emit('HoverRankingDataDelete')
    },
    highlightSelected(element) {
      var vm = this
      var geolvl = vm.geolevels.filter((item) => item.level === parseInt(element.level))
      if (geolvl.length === 0) { return '' }
      if (parseInt(element.objectid) === geolvl[0].id) { return 'ranking-bolder' }
    }
  }
}
</script>

<style lang="scss" scoped>
.ranking-table-section {
  height: 100%;
  width: 100%;
  overflow: hidden;

  .ranking-table-errmsg {
    text-align: center;
    width: 100%;
    margin-top: 50px;
    font-family: 'Montserrat-SemiBold',sans-serif;
  }

  .ranking-table-desc {
    padding: 7px;
    margin-bottom: 5px;
    line-height: 1.4;
  }

  .ranking-table-container {
    font-family: 'Montserrat-Regular',sans-serif;
    width: 100%;
    height: calc(100vh - 255px);
    overflow: scroll;
  }

  .ranking-table {
    max-height: 100%;
    width: 100%;
    font-size: 12px;

    tr:hover {
      font-size: 14px;
      font-family: 'Montserrat-SemiBold',sans-serif;
      cursor: pointer;
      color: #009999;
    }

    td, td * {
      vertical-align: middle;
    }

    td:nth-child(1) {
      text-align: right;
      padding: 5px;
    }
    td:nth-child(2) {
      width: 40%;
      padding: 3px 4px 3px 4px;

      div {
        height: 25px;
        background-color: #99C9C5;
        border-radius: 2px;
        box-shadow: 2px 2px 1px lightgrey;
      }
    }
    td:nth-child(3){
      padding: 5px;
      width: 20%;
    }

    .ranking-unit {
      font-size: 0.8em;
    }

    .ranking-bolder {
      font-size: 14px;
      font-family: 'Montserrat-SemiBold',sans-serif;
      cursor: pointer;
      color: #009999;
    }
  }
}
</style>
